import { render, staticRenderFns } from "./BottomAds.vue?vue&type=template&id=c3812a34&scoped=true&"
import script from "./BottomAds.vue?vue&type=script&lang=js&"
export * from "./BottomAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3812a34",
  null
  
)

export default component.exports